import BaseApi from "../../../services/Api";
import Swal from "sweetalert2";
import React, {useEffect, useState} from "react";
import Tooltip from "../../Popups/Tooltip";
import {Modal, Spinner} from "react-bootstrap";
import { format } from "date-fns";
import ptBR from 'date-fns/locale/pt-BR';


const ModalBannerInfo = ({
  idBanner, children
}) => {
  const [isLoading, setLoading] = React.useState(true);
  const [isSaving, setSaving] = React.useState(true);
  const [isShow, setShowModal] = React.useState(false);

  const [creationDate, setCreationDate] = useState('');
  const [title, setTitle] = useState('');
  const [image, setImage] = useState(null);
  const [calloutPhrase, setCalloutPhrase] = React.useState('');
  const [buttonText, setButtonText] = React.useState('');
  const [buttonLink, setButtonLink] = React.useState('');


  const handleClose = () => {
    setShowModal(false);
  }

  const requestData = () => {
    setLoading(true);
    BaseApi.get(`/banner/${idBanner}`).then(res => {
      let data = res.data;
      setTitle(data.title);
      setCalloutPhrase(data.callout_phrase);
      setButtonText(data.button_text);
      setButtonLink(data.button_link);
      setImage(data.image);
      setCreationDate(data.created_at);
      setLoading(false);
      setSaving(false);
    }).catch(err => {
      console.log(err);
      Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || 'Ocorreu um erro ao carregar este banner ou o banner não foi encontrado.', 'error');
      setShowModal(false);
    })
  }

  useEffect(() => {
    if(isShow) {
        requestData();
    } else {
        setTitle('');
        setCalloutPhrase('');
        setButtonLink('');
        setButtonText('');
        setImage(null);
        setLoading(true);
        setSaving(true);
    }
  }, [isShow])

  return (
    <>
      {children &&
        React.cloneElement(children, { onClick: (e) => setShowModal(true) })}
      {!children && (
        <Tooltip text={"Informações do Banner"}>
          <button
            className={`btn btn-${idBanner ? "warning" : ""} text-white fa-bold`}
            onClick={(e) => setShowModal(true)}
          >
            <i className={`bi bi-${idBanner ? "person-gear" : "plus"}`}></i>
          </button>
        </Tooltip>
      )}
      <Modal
        centered
        scrollable
        onHide={handleClose}
        show={isShow}
        animation={true}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Informações do Banner</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center justify-content-center">
            {isLoading && (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            )}
          </div>
          {!isLoading && (
            <>
              <div className="row">
                
                <div className="form-group mb-3">
                  <label htmlFor="title">Título</label>
                  <input
                    type="text"
                    className="form-control"
                    id="title"
                    placeholder="Insira o título"
                    value={title}
                  readonly/>
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="calloutPhrase">Frase de destaque</label>
                  <textarea
                    type="text"
                    className="form-control"
                    id="callout_phrase"
                    placeholder="Insira a frase de destaque"
                    value={calloutPhrase}
                   
                  readonly/>
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="buttonText">Texto do botão</label>
                  <input
                    type="text"
                    className="form-control"
                    id="button_text"
                    placeholder="Texto do botão"
                    value={buttonText}
                   
                  readonly/>
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="buttonLink">Link do botão</label>
                  <input
                    type="url"
                    className="form-control"
                    id="button_link"
                    placeholder="Link para o botão"
                    value={buttonLink}
                   
                  readonly/>
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="creationDate">Data de criação</label>
                  <input
                    type="creationDate"
                    className="form-control"
                    id="creationDate"
                    value={format(new Date(creationDate), "d 'de' MMMM 'de' yyyy 'às' H:mm", { locale: ptBR })}
                   
                  readonly/>
                </div>
                

                <div className="form-group mb-3">
                  <label htmlFor="image">Imagem</label>

                
                  
                  {idBanner ? (
                    <div className="d-flex justify-content-center align-items-center mt-2">
                      <img
                        src={image instanceof File ? URL.createObjectURL(image) : image}
                        alt="imagem"
                        style={{ minWidth: 250, width: 350, objectFit: 'cover' }}
                      />
                    </div>
                  ) : 
                    null
                  }

                  {image && !idBanner && (
                    <div className="d-flex justify-content-center align-items-center mt-2">
                      {idBanner ? <img src={image} alt="imagem" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                        : <img src={URL.createObjectURL(image)} alt="imagem" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                      }
                      </div>
                    )
                  }
                </div>


              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex align-items-center w-100">
            <div className="d-block me-auto"></div>
            <div className="d-block ms-auto">
              <button
                className="btn btn-danger text-white me-2"
                onClick={handleClose}
              >
                Close
              </button>
             
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalBannerInfo;